import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";

type UnsavedChangesDialogProps = {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
};

export function UnsavedChangesDialog({ open, onKeepEditing, onDiscard }: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onClose={onKeepEditing} aria-describedby="unsaved-changes-dialog-description">
      {/* Beside the title, not inside it: a nested button's label would become part of the
          dialog's accessible name. */}
      <Stack direction="row" spacing={2} sx={{ alignItems: "center", pr: 1 }}>
        <DialogTitle sx={{ flex: 1 }}>Unsaved changes</DialogTitle>
        <IconButton aria-label="close" onClick={onKeepEditing} sx={{ color: (theme) => theme.palette.grey[500] }}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          If you leave this page, your unsaved changes will be lost. Would you like to continue editing?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onDiscard}>
          Leave and discard
        </Button>
        <Button variant="contained" onClick={onKeepEditing} autoFocus>
          Continue editing
        </Button>
      </DialogActions>
    </Dialog>
  );
}
